import clsx from "clsx";
import type { HTMLAttributes } from "react";
import { forwardRef } from "react";

import styles from "./item.module.css";

type Props = HTMLAttributes<HTMLSpanElement>;

const ItemIcon = forwardRef<HTMLSpanElement, Props>(({ children, className, ...otherProps }, ref) => {
    return (
        <span {...otherProps} ref={ref} className={clsx(styles.item_icon, className)}>
            {children}
        </span>
    );
});

ItemIcon.displayName = "ItemIcon";

export { ItemIcon };
export type { Props as ItemIconProps };
